import { CameraIntegration, epochTimeOfSelectedEvent } from './base';
import { router } from '@qsrsoft/myq-core';
import Bowser from 'bowser';
const baseURL = import.meta.env.VITE_APP_SECURITY_API_BASE_URL;

export class DTIQ extends CameraIntegration {
  constructor(...args) {
    super(...args);
    this.cameraProviderName = 'DTIQ';

    this.isLoginThroughTheirCrappyPortal = true;
    this.getBrowserAndOS();
  }

  getBrowserAndOS() {
    const { browser, os } = Bowser.parse(window.navigator.userAgent);
    this.browserName = browser.name.toLowerCase();
    this.osName = os.name.toLowerCase();
  }

  checkForCredentials() {
    const accessToken = this.camera?.accessToken;
    if (!accessToken) {
      this.isAuthenticated = false;
      return;
    }

    if (accessToken === 'dtiq_location_access_denied') {
      this.isAuthenticated = false;
      throw Error('You do not have access to this dtiq location');
    }

    const invalidTokens = [
      'refresh_token_not_available',
      'refresh_token_invalid',
    ];

    if (invalidTokens.includes(accessToken)) {
      this.isAuthenticated = false;
      return;
    }

    this.isAuthenticated = true;
  }

  async submitCredentials() {
    let url;
    const {
      dtiqIdentityHost,
      dtiqHostEnvironment,
      dtiqClientId,
      dtiqRedirectUri,
      dtiqQaHost,
      stateQueryParamterValueForSecurity,
    } = this.camera;
    // debug logging removed (use a debug flag elsewhere if needed)
    if (!dtiqIdentityHost || !dtiqClientId || !dtiqRedirectUri)
      throw Error('Missing DTiQ client configuration');

    if (dtiqHostEnvironment === 'QA')
      url = `${dtiqQaHost}/DTiQ360IdentityServer/connect/authorize`;
    else if (dtiqHostEnvironment === 'PROD')
      url = `${dtiqIdentityHost}/connect/authorize`;
    else throw Error('Invalid DTiQ host environment', { dtiqHostEnvironment });

    // set DTIQCamera in local storage
    localStorage.setItem('DTIQCamera', JSON.stringify(this.camera));
    // store current route (vue-router v4 uses a ref for currentRoute)
    try {
      const fullPath =
        router?.currentRoute?.value?.fullPath ||
        router?.currentRoute?.fullPath ||
        window.location.pathname;
      localStorage.setItem('DTIQRedirectPath', fullPath);
    } catch (_) {
      console.error('Error storing redirect path:', _);
      // fallback to window location
      localStorage.setItem('DTIQRedirectPath', window.location.pathname);
    }

    const params = {
      client_id: dtiqClientId,
      scope: 'openid SystemAPI locations cameras offline_access',
      response_type: 'code',
      response_mode: 'form_post',
      redirect_uri: `${dtiqRedirectUri}/security/dtiq_authorization_response`,
      // redirect_uri: 'https://pr-16835.staging-preview.myqsrsoft.com/security/dtiq_authorization_response',
      state: stateQueryParamterValueForSecurity,
    };

    url += `?${new URLSearchParams(params).toString()}`;

    // Set legitimate external navigation flag before navigating (if available)
    try {
      // Check if filterLoadTool utility is available (parent repo specific)
      if (
        typeof window !== 'undefined' &&
        window.setLegitimateExternalNavigation
      ) {
        window.setLegitimateExternalNavigation(true);
        console.log(
          '[DTIQ] Set legitimate external navigation flag before redirecting to:',
          url,
        );
      } else {
        console.debug(
          '[DTIQ] filterLoadTool not available, continuing without setting navigation flag',
        );
      }
    } catch (error) {
      console.debug('[DTIQ] Error setting navigation flag:', error);
    }

    window.location = url;
  }

  async fetchThumbnails() {
    // DTiQ retrieves thumbnails from the script
    return [];
  }

  getUrlVideo() {
    const { dtiqHostEnvironment, dtiqApiHost, dtiqQaHost } = this.camera;

    if (dtiqHostEnvironment === 'QA')
      return `${dtiqQaHost}/DTiQ360SystemAPI/GetVideoPanel`;
    if (dtiqHostEnvironment === 'PROD') return `${dtiqApiHost}/GetVideoPanel`;
    throw Error('Invalid DTiQ host environment', { dtiqHostEnvironment });
  }

  async fetchVideo() {
    // DTiQ does not work on ios for either safari or chrome
    if (this.osName === 'ios') {
      throw Error(
        `DTiQ video player is not supported on an ${this.osName} device.`,
      );
    }
    // DTiQ does not work on safari for both macos and ios
    if (this.browserName === 'safari') {
      throw Error(
        `DTiQ video player is not supported using the ${this.browserName} browser`,
      );
    }

    const { time } = this.event;
    const epochMilliSeconds = epochTimeOfSelectedEvent({
      format: 'milli',
      time,
      vendor: 'dtiq',
    });

    const wholeUrl = `${baseURL}/security/dtiq-iframe/v1/${this.orgId}/${this.camera?.accessToken}/${this.camera.dtiqLocationId}/${epochMilliSeconds}`;

    const nowPlaying = {
      cameraSelectionOpen: true,
      cameraSelectionToggle: false,
      calendar: false,
      timeBar: true,
      forceInitTime: true,
      devInfoPanel: false,
      timeFrame: 30,
      playOnSetVideo: false,
    };

    nowPlaying.video = {
      src: `${wholeUrl}?${new URLSearchParams().toString()}`,
      type: 'iframesrc',
    };

    return nowPlaying;
  }
}
